import { render, staticRenderFns } from "./approval-dialog.vue?vue&type=template&id=06811a64&scoped=true"
import script from "./approval-dialog.vue?vue&type=script&lang=ts"
export * from "./approval-dialog.vue?vue&type=script&lang=ts"
import style0 from "./approval-dialog.vue?vue&type=style&index=0&id=06811a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06811a64",
  null
  
)

export default component.exports